import React from 'react';
import { getTier, getTopPercent, STAT_LABELS } from './achievementUtils';

interface MedalTooltipProps {
    rank: number;
    totalPlayers: number;
    stat: string;
    visible: boolean;
}

const MedalTooltip: React.FC<MedalTooltipProps> = ({ rank, totalPlayers, stat, visible }) => {
    const tier = getTier(rank);
    const topPercent = getTopPercent(rank, totalPlayers);
    const statLabel = STAT_LABELS[stat];

    if (!visible) return null;

    return (
        <div className="medal-tooltip">
            <div className="medal-tooltip__stat">{statLabel?.full || stat}</div>
            <div className="medal-tooltip__rank">
                #{rank} <span className="medal-tooltip__total">af {totalPlayers}</span>
            </div>
            <div className="medal-tooltip__percentile">{topPercent}</div>
            <div
                className="medal-tooltip__tier"
                style={{ color: tier.tierColor }}
            >
                {tier.label}
            </div>
            <div className="medal-tooltip__arrow" />
        </div>
    );
};

export default MedalTooltip;
